export function shouldSetSamesiteCookie() {
  if (window && navigator) {
    const isHttps = window.location.protocol === 'https';
    const isSafariOnOlderMacOs = navigator.userAgent.indexOf('Mac OS X 10_15') === -1 &&
      navigator.userAgent.indexOf('Mac OS X') !== -1 &&
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1;
    return isHttps && !isSafariOnOlderMacOs;
  }
}